import TemplateSignUp from './TemplateSignUp'

export default TemplateSignUp
